<template>
  <div class="home">
    <img class="bgiss" src="../assets/images/bgc.png" alt="">
    <div class="classification">
      <el-row class="buttons">
        <el-col :span="24">
          <el-button type="text">
            <div @click="examination" class="grid-content bg-purple-dark">
              <img src="../assets/images/training.png" alt="" />
            </div>
          </el-button>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
    };
  },
  created() {
    // this.getVideo();
		this.xUH();
  },

  methods: {
    async xUH () {
      await this.$http.get(
        "/RQCode"
      );
    },
    examination () {
      window.sessionStorage.clear();
      this.$router.push("/practicaltraining");
    }
  }
};
</script>

<style lang="less" scoped>
.bgiss{
  width: 100%;
  height: 100%;
  position: absolute;
}
.logbgc {
  position: absolute;
  width:900px;
  top:30%;
  left: 10%;
}
.home {
  height: 100%;
}
.classification {
  width: 513px;
  position: absolute;
  right: 1%;
  top: 24%;
}
.el-col {
  position: relative;
}
.tops .el-col {
  background-color: snow;
}
.tops .el-col,
.buttons .el-col {
  width: 100%;
  border-radius: 17px;
}
.tops .el-col {
  color: #e3925c;
  height: 155px;
  margin-bottom: 14px;
}
.tops img {
  height: 100%;
  width: 102%;
  display: inline-block;
  // margin-left:335px;
  // margin-top: 6px;
}
.buttons .el-col {
  margin-top: 14px;
  overflow: hidden;
}
.buttons img {
  border-radius: 10px;
  width: 100%;
}
.lefs img {
  // height: 80%;
  width: 102%;
  height: 100%;
  display: inline-block;
  margin-left:-7px;
  // margin-top: 2px;
}
.lefs .el-col {
  width: 250px;
  height: 157px;
  background-color: snow;
  border-radius: 17px;
  color: #e7a854;
  font-size: 11px;
}

.lefs .el-col h1 {
  top: -3px;
}
.lefs .el-col span {
  left: 1.88rem;
  top: 2.25rem;
}
.lefs .lefscol {
  margin-right: 12px;
  color: #d15c61;
}
.grid-content {
  position: relative;
}
.classification span {
  position: absolute;
  top: 2.6875rem;
  left: 2.4375rem;
  font-size: 10px;
}
.classification h1 {
  position: absolute;
  font-weight: 400;
  top: -0.8125rem;
  left: 1.875rem;
}
.buttons .el-col {
  color: #49acf8;
}
.tops .el-col h1,
.buttons .el-col h1 {
  font-size: 30px;
}
.buttons .el-col h1 {
  font-size: 50px;
}
.tops .el-col span,
.buttons .el-col span {
  top: 2.625rem;
  font-size: 13px;
}
.buttons .el-col span {
  top: 5.155rem;
  font-size: 1.55rem;
}
.video-js .vjs-icon-placeholder {
  width: 100%;
  height: 100%;
  display: block;
}

.video-js .vjs-icon-placeholder {
  width: 100%;
  height: 100%;
  display: block;
}
/deep/.el-dialog__body {
  padding: 0;
}
/deep/.el-dialog__header {
  display: none;
}
/deep/.el-dialog {
  width: 65% !important;
}
.el-button {
  background-color: transparent;
}
</style>
